module.exports = __webpack_public_path__ + "img/2358.968652d9.gif";